import React from 'react';
import './Styles.css';
import { useGlobalContext } from '../../context/GlobalContext';
import { Breadcrumbs } from '@ids/react-breadcrumbs';

const BreadcrumbRow = ({ cssClasses }) => {
  const { breadcrumbs } = useGlobalContext();

  return (
    <Breadcrumbs className={`breadcrumb-container ${cssClasses}`}>
      {breadcrumbs.map((x, index) => (
        <>
          {index === breadcrumbs.length - 1 ? (
            <span key={index}>{x.title}</span>
          ) : (
            <a key={index} href={x.link} className="breadcrumb-link">
              {x.title}
            </a>
          )}
        </>
      ))}
    </Breadcrumbs>
  );
};

export default BreadcrumbRow;
